import { styled } from '@mui/material';

import { FrameIcon, InstanceIcon } from '@app-velocity/icons';

export type FigmaNodeProps = {
  element: Pick<SceneNode, 'id' | 'name' | 'type'>;
};

const StyledFigmaNode = styled('div')(({ theme }) => ({
  fontSize: 12,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
  svg: {
    fill: 'var(--icon-icon-secondary-color)',
  },
}));

export const FigmaNode = ({ element: { name, type } }: FigmaNodeProps) => {
  const getIcon = () => {
    switch (type) {
      case 'INSTANCE':
        return <InstanceIcon />;
      case 'FRAME':
        return <FrameIcon />;
    }

    return null;
  };

  return (
    <StyledFigmaNode>
      {getIcon()}
      {name}
    </StyledFigmaNode>
  );
};
